import type { ErrorCode } from '@ps/web-core-enums';
import type { FieldState } from 'final-form';

import type { Client2TrackedTranslation, Values } from '../types/i18n';

import { TXTCLI_Required } from './validators.messages';

export interface ValidatorTranslation extends Client2TrackedTranslation {
  values?: Values;
}

export interface Error {
  valid?: boolean | RegExp;
  message?: ValidatorTranslation | ValidatorTranslation[];
  value?: string;
  suggestedNames?: string[];
  code?: ErrorCode;
}

export type ErrorOrPromise = Error | Promise<Error>;

export type Errors = Error[];

/* eslint-disable @typescript-eslint/no-explicit-any */
export type Validator<T = ErrorOrPromise> = (
  value?: any,
  allValues?: any,
  meta?: FieldState<any>
) => T;

export type Validators = Validator[];

export const required =
  (message: Error['message'] | null = TXTCLI_Required) =>
  (value: string) => ({
    valid: !!value,
    message: message !== null ? message : undefined
  });
